import { useState } from "react";
import { useParams } from "react-router-dom";
import { apiURL } from "../api";

export default function CreateSolutionsToTask({ taskUuid }) {
  const [code, setCode] = useState("");
  const [codeLanguage, setCodeLanguage] = useState("javascript");
  const [solutionNumber, setSolutionNumber] = useState(1);
  const [text, setText] = useState("");

  const { uuid } = useParams();

  const handleCreateTaskSolution = (event) => {
    event.preventDefault();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "solution.create",
        params: {
          taskUuid: uuid,
          solutionNumber: solutionNumber,
          text: text,
          code: code,
          codeLanguage: codeLanguage,
        },
      }),
    };

    fetch(apiURL + "/admin", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw new Error(response.error.message);
        }
      })
      .catch((error) => {
        console.error("Failed to create task solution:", error);
      })
      .finally(() => {});
  };

  return (
    <form className="mx-5" onSubmit={handleCreateTaskSolution}>
      <div className="mb-3">
        <label htmlFor="TaskCreateSolution" className="col-form-label">
          Code:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="TaskCreateSolution"
          value={code}
          onChange={(event) => setCode(event.target.value)}
        ></textarea>
      </div>
      <div className="mb-3">
        <label
          htmlFor="TaskCreateSolutionCodeLanguage"
          className="col-form-label"
        >
          Code Language:
        </label>
        <select
          className="form-select"
          id="TaskCreateSolutionCodeLanguage"
          aria-label="Code Language"
          onChange={(event) => setCodeLanguage(event.target.value)}
          defaultValue="javascript"
        >
          <option value="javascript">javascript</option>
          <option value="html">html</option>
          <option value="jsx">jsx</option>
          <option value="css">css</option>
          <option value="scss">scss</option>
        </select>
      </div>
      <div className="mb-3">
        <label htmlFor="TaskCreateSolutionNumber" className="col-form-label">
          Solution Number:
        </label>
        <textarea
          type="number"
          className="form-control"
          id="TaskCreateSolutionNumber"
          value={solutionNumber}
          onChange={(event) => setSolutionNumber(Number(event.target.value))}
        ></textarea>
      </div>
      <div className="mb-3">
        <label htmlFor="TaskCreateSolutionText" className="col-form-label">
          Text:
        </label>
        <textarea
          type="text"
          className="form-control"
          id="TaskCreateSolutionText"
          value={text}
          onChange={(event) => setText(event.target.value)}
        ></textarea>
      </div>
      <button type="submit" className="btn btn-primary col-2">
        Create
      </button>
    </form>
  );
}
